module.exports = __webpack_public_path__ + "img/symbol_11.7c342cde.png";